enum StatusDeliverableDocument  {
    Accept = 1,
    Reject = 2,
    WaitingForVerification = 3,
    WaitingForAttach = 4,
    Waive= 5
}

export default StatusDeliverableDocument